"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSaveUnavailabilityMiddleware = void 0;
const ac_1 = require("@app/ac");
const ActionsTimeOffConflict_1 = require("@app/component/modals/edit-unavailability/ActionsTimeOffConflict");
const graphql_1 = require("@app/gql-types/graphql");
const timeoff_create_half_day_over_shift_1 = require("@app/request/timeoff-create-half-day-over-shift");
const store_1 = require("@app/store");
const util_1 = require("@app/util");
const use_workspace_unavailability_categories_1 = require("@app/util/hooks/use-workspace-unavailability-categories");
const use_modal_1 = require("@app/util/modal/use-modal");
const moment_1 = __importDefault(require("moment"));
const useSaveUnavailabilityMiddleware = (isEmployeeCalendar) => {
    const dispatch = (0, store_1.useRootDispatch)();
    const { closeModal, openModal } = (0, use_modal_1.useModal)();
    const shifts = (0, store_1.useRootSelector)((state) => state.shifts);
    return async (data) => {
        const shiftsInDay = shifts.filter((shift) => shift.userId === data.user &&
            (0, moment_1.default)(data.period?.start).isSame(shift?.period?.start, 'day'));
        // const isAvailabilityOrUnavailability =
        //   data.categoryId === AVAILABILITY_VALUE ||
        //   data.categoryId === UNAVAILABILITY_VALUE
        if (data.periodType === graphql_1.PeriodType.HalfDay && !(0, util_1.isValue)(data.id)) {
            const shift = shiftsInDay[0];
            const result = await (0, timeoff_create_half_day_over_shift_1.mutateTimeOffCreateHalfDayOverShiftMutation)({
                user: data.user ?? '',
                attachments: data.attachments ? data.attachments.map((item) => item.id) : [],
                shift: shift?.id,
                category: data.categoryId,
                note: data.note,
                atTheStartOfShift: data?.halfDayOption === 'start',
            });
            if ((0, util_1.isValue)(result)) {
                util_1.notification.success({ code: 'success', message: '' });
            }
            closeModal();
        }
        else {
            const isAvailOrUnavail = data.categoryId === use_workspace_unavailability_categories_1.AVAILABILITY_VALUE ||
                data.categoryId === use_workspace_unavailability_categories_1.UNAVAILABILITY_VALUE;
            const sanitizedData = {
                ...data,
                period: {
                    start: data.period?.start?.toJSON(),
                    end: data.period?.end?.toJSON(),
                },
                attachments: data.attachments?.map((att) => att.id),
                available: isAvailOrUnavail
                    ? data.categoryId === use_workspace_unavailability_categories_1.AVAILABILITY_VALUE
                    : undefined,
                note: data.note,
                recurrenceUpdateFollowing: (0, util_1.isDefined)(data.recurrence) && (0, util_1.isUndefined)(data.id),
            };
            const result = await dispatch((0, ac_1.setAvailabilityOrTimeOff)({
                // @ts-expect-error
                evts: [sanitizedData],
                unavId: !(0, util_1.isValue)(data.id) ? null : data.id,
            }));
            if (!isEmployeeCalendar && result?.conflictingShifts?.length > 0) {
                openModal(ActionsTimeOffConflict_1.ActionsTimeOffConflict, {
                    conflictingShifts: result.conflictingShifts,
                    resultTimeOffs: result.timeOffs,
                    afterClose: () => {
                        closeModal();
                    },
                });
            }
            else if ((0, util_1.isValue)(result) && !(0, util_1.isValue)(result.error)) {
                util_1.notification.success({ code: 'success', message: '' });
                closeModal();
            }
        }
    };
};
exports.useSaveUnavailabilityMiddleware = useSaveUnavailabilityMiddleware;
